module.exports = __webpack_public_path__ + "media/tutorial-4.png";